/*
 * @Description: 路由
 * @Date: 2025-07-25 10:31:12
 */
export const route = [
  {
    path: '/audit-log-report-list',
    name: 'audit-log-report-list',
    meta: { title: '任务审核日志报告' },
    component: () => import('../views/audit-log-list.vue')
  }
];
